export function setupDefaultLanguage() {
  const browserLang = navigator.language || navigator.userLanguage;
  const defaultLang = browserLang.includes('zh') ? 'zh-CN' : 'en';
  
  localStorage.setItem('locale', defaultLang);
  return defaultLang;
}
